import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScInstallSteps = styled.div<{ slidesNumber: number }>`
  display: flex;
  flex-direction: column;
  .title {
    text-align: center;
    font-style: normal;
    font-size: 16px;
    line-height: 28px;
    margin: 0;
    color: ${({ theme }) => theme.whiteColor};
    margin-bottom: 16px;
  }
  .swiper-slide {
    height: 100%;
  }
  .swiper-slide {
    height: auto;
  }
  .steps-wrp {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .item-wrp-steps {
    display: flex;
    flex-direction: column;
    padding: 0 19px;
    min-height: 100%;
    align-items: center;
    width: 100%;
  }

  .image {
    max-width: 100%;
    margin-top: auto;
    height: 100%;
  }

  .swiper-pagination {
    position: static;
    gap: 4px;
    width: 238px;
    display: grid;
    margin-top: 16px;
    height: 8px;
    grid-template-columns: ${({ slidesNumber }) =>
      `repeat(${slidesNumber}, 1fr)`};
  }

  .swiper-pagination-bullet {
    cursor: pointer;
    &:before {
      position: relative;
      content: '';
      width: 44px;
      height: 8px;
      display: block;
      border-radius: 2px;
      transition: background-color 0.3s;
      background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    }

    @media (hover: hover) {
      &:hover {
        &:before {
          background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.4)};
        }
      }
    }

    &-active {
      &:before {
        background-color: ${({ theme }) => theme.whiteColor};
      }

      @media (hover: hover) {
        &:hover {
          &:before {
            background: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }
    @media (${device.mobile}) {
      &:before {
        width: 44px;
        height: 8px;
      }
    }
  }

  @media (${device.desktop}) {
    .item-wrp-steps {
      padding: 0 25px;
      min-height: 100%;
    }
  }

  @media (${device.mobile}) {
    padding: 0;
    .button-wrp {
      display: flex;
      justify-content: center;
      margin-top: 32px;
    }
  }
`;
